import { Switch } from '@mui/material';
import { PaginatorModel } from 'model/utilModels/PaginatorModel';
import { ResponseModel } from 'model/utilModels/ResponseModel';
import React, { useEffect, useMemo, useState } from 'react'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { FinancialProtectionMessageService } from 'services/menu/financialProtectionMessage/FinancialProtectionMessageService';
import { msgTypes } from 'constants/msgTypes';
import { FinancialProtectionMessageModel } from 'model/screensModels/FinancialProtectionMessageModel';
import { conformationAlert } from 'services/shared/alert';
import { Form, Formik } from 'formik';
import CustomTableGrid from 'components/uiComponents/CustomTableGrid';
import FormikControl from 'components/wrapperComponents/FormikControl';
import { FinancialProtectionMessageSchema } from 'schemas/menu/financialProtectionMessage/FinancialProtectionMessageSchema';
import Tooltip from '@mui/material/Tooltip';

const FinancialProtectionMessageList = ({ setFlag, updateRecord, loadRecentGuidelineMessage }) => {
  const [financialMessageList, setFinancialMessageList] =  useState<ResponseModel | null>(null); 
  const paginatorModel: PaginatorModel = new PaginatorModel();
  const [pagination, setPagination] = useState({
    pageSize: paginatorModel.pageSize,
    pageNumber: paginatorModel.pageNumber,
    filter: "",
    orderBy: "",
    desc: "",
  })

  const columns = useMemo(() =>
    [
      {
        accessorKey: "financialProtectionMessage",
        header: "Message",
        size: 150
      },
      {
        accessorKey: "status",
        header: "Status",
        size: 50,
        Cell: ({ cell, row }) => (
          <Switch
            name="status"
            checked={row?.original?.status}
            onChange={() => {
              updateStatus(row.original)
            }}
          />
        ),
      },
      {
        header: 'Action',
        Cell: ({ renderedCellValue, row }) => (
          <div className='d-flex'>
            {/* <EditIcon onClick={()=>{editRecord(row.original)}} color='primary'/>
              <DeleteIcon onClick={()=>{deleteRecord(row.original)}} color='error' /> */}
            <Tooltip title="Edit">
              <EditIcon fontSize="small" onClick={() => { editRecord(row.original) }} />
            </Tooltip>
            <Tooltip title="Delete">
              <DeleteIcon fontSize="small" onClick={() => { deleteRecord(row.original) }} />
            </Tooltip>
          </div>
        ),
        size: 10,
        grow: false,
      },

    ], []);

  useEffect(() => {
    getFinancialMessageList();
  }, [pagination.pageNumber, pagination.pageSize, pagination.filter, pagination.orderBy, pagination.desc])

  //End:: UseEffect Hooks 

  //Prepare request body to get blog list
  const prepareRequest = () => {
    const requestBody = new PaginatorModel();
    requestBody.pageNumber = pagination.pageNumber;
    requestBody.pageSize = pagination.pageSize;
    requestBody.filter = pagination.filter;
    requestBody.orderBy = pagination.orderBy;
    requestBody.desc = pagination.desc;
    return requestBody;
  }

  //Get Financial Protection list
  const getFinancialMessageList = async () => {
    const requestBody = prepareRequest();
    const res = await FinancialProtectionMessageService.getFinancialMessageList(requestBody);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setFinancialMessageList(res);
    }
  }

  //Open Form To edit Record
  const editRecord = (record: FinancialProtectionMessageModel) => {
    updateRecord(record);
    setFlag(true)
  }

  const deleteRecord = async (record: FinancialProtectionMessageModel) => {
    const requestData: FinancialProtectionMessageModel = new FinancialProtectionMessageModel();
    requestData.financialProtectionMessageId = record.financialProtectionMessageId

    const deleteFlag = await conformationAlert(msgTypes.CONFORMATION_MESSAGE.DELETE_RECORD, msgTypes.CONFORMATION_ICON.ERROR, "delete");

    // const deleteFlag = await conformationAlert(msgTypes.CONFORMATION_MESSAGE.DELETE_RECORD, msgTypes.CONFORMATION_ICON.ERROR);
    if (deleteFlag) {
      const res = await FinancialProtectionMessageService.deleteFinancialMessage(requestData);
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        getFinancialMessageList();
        loadRecentGuidelineMessage();
      }
    }
  }

  const initialValues = {}
  const onSubmit = () => {
    getFinancialMessageList();
  }


  const updateStatus = async (record: FinancialProtectionMessageModel) => {
    const requestData: FinancialProtectionMessageModel = new FinancialProtectionMessageModel();
    requestData.financialProtectionMessageId = record.financialProtectionMessageId;
    requestData.financialProtectionMessage = record.financialProtectionMessage ? record.financialProtectionMessage : '';
    requestData.status = !record.status;

    const updateStatusFlag = await conformationAlert(
      msgTypes.CONFORMATION_MESSAGE.UPDATE_RECORD,
      msgTypes.CONFORMATION_ICON.WARNING,
      "Yes! Update"
    );
    if (updateStatusFlag) {
      const res = await FinancialProtectionMessageService.addFinancialProtectionMessage(requestData);
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        getFinancialMessageList();
      }
    }
  };


  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={FinancialProtectionMessageSchema}
      onSubmit={onSubmit}
    >
      {
        formik =>
        (
          <Form>
              {financialMessageList ? (
            <CustomTableGrid
              item={
                <FormikControl
                  control='materialTable'
                  tableColumn={columns}
                  tableData={financialMessageList}
                  setPagination={setPagination}
                />
              }
            />
          ) : null}
          </Form>
        )
      }
    </Formik>
  )
}

export default FinancialProtectionMessageList